export default class About {
   constructor() {
      const inner = $('.about-text--inner');

      // const itemsWithAbout = window.entries.entries.filter(item => item['about-hyperimage-atlas'] !== undefined);
      const itemsWithAbout = window.entries.entries.slice(0, 20);
      for(var i=0; i<itemsWithAbout.length; i++) {
         if(!itemsWithAbout[i]['about-hyperimage-atlas']){
            inner.append(`<span class="spacer"></span>`);
            // break;
         } else {
            let copy = itemsWithAbout[i]['about-hyperimage-atlas']
               .replaceAll('\n\n','<span class="spacer"></span>')
               .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
               .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'); // raw URLs
            inner.append(`<p>${copy}</p>`);
         }
      }
      inner.append(`<span class="spacer"></span>`);
      
      /*
      for(var j=27;j<35;j++) {
         if(!window.entries.entries[j]['readme']) break;
         let copy2 = `${window.entries.entries[j]['readme'].replaceAll('\n\n','<span class="spacer"></span>')}`;
         inner.append(`<p class='copy'>${copy2}</p>`);
      }
      inner.append(`<br>`);
      */
      
      const itemsWithRole = window.entries.entries.filter(item => item.role !== undefined);
      for(let n=0; n<itemsWithRole.length; n++) {
         // for(var n=20;n<26;n++) {
            // if(!window.entries.entries[n]['role']) break;
            // let copy3 = `${window.entries.entries[n]['role']}: ${window.entries.entries[n]['first-name']} ${window.entries.entries[n]['last-name']}<br>`;
         if(itemsWithRole[n]['first-name'] || itemsWithRole[n]['last-name']) {
            let copy3 = `${itemsWithRole[n]['role']}: ${itemsWithRole[n]['first-name']} ${itemsWithRole[n]['last-name']}<br>`;
            inner.append(`<p class='copy'>${copy3}</p>`);
         }
      }

      let copyright = `
         <br><p class='copy'>&copy; ${new Date().getFullYear()} Sheung Yiu.</p>
      `;
      inner.append(copyright);

      $('.about-link').click(function(e){
         if(!e.metaKey && !e.ctrlKey && !e.shiftKey) {
            e.preventDefault();
            $('body').removeClass('bib-open');
            $('body').toggleClass('about-open');
         }
      });

      $('.about--close').click(function(e){
         e.preventDefault();
         $('body').removeClass('about-open');
      });
   }
}